import { render, staticRenderFns } from "./ldp.vue?vue&type=template&id=9891dafc&scoped=true"
import script from "./ldp.vue?vue&type=script&lang=js"
export * from "./ldp.vue?vue&type=script&lang=js"
import style0 from "./ldp.vue?vue&type=style&index=0&id=9891dafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9891dafc",
  null
  
)

export default component.exports